import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useProductAttributes from 'data-hooks/useProductAttributes/index';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import PDPProductDetailsLinkSection from '../PDPProductDetailsModal/PDPProductDetailsLinkSection';
import PDPInfoSectionLayout from './PDPInfoSectionLayout';

// Details tab: the construction list that today only exists inside the
// details-and-care full-screen modal
const PDPInfoDetailsSection = () => {
  const $ = _c(15);
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const {
    data: t0
  } = useProductAttributes();
  const {
    constructionDetails,
    productPDF,
    assemblyDetailsPDF
  } = t0;
  const name = basicDetails?.name ?? "";
  const tearSheetLink = productPDF ? `https://jb-img.co/public_img/${productPDF}` : undefined;
  const assemblyDetailsLink = assemblyDetailsPDF ? `https://jb-img.co/public_img/${assemblyDetailsPDF}` : undefined;
  const t1 = `${name} Details`;
  let t2;
  if ($[0] !== t1) {
    t2 = t1.trim();
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== constructionDetails) {
    t3 = constructionDetails ?? [];
    $[2] = constructionDetails;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = t3.map(_temp);
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="md:[column-count:2] md:[column-gap:3rem]">{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== assemblyDetailsLink || $[9] !== tearSheetLink) {
    t6 = (!!tearSheetLink || !!assemblyDetailsLink) && <div className="mt-6 flex flex-row gap-6 max-[767px]:flex-col"><PDPProductDetailsLinkSection link={tearSheetLink}>Download Tear Sheet</PDPProductDetailsLinkSection><PDPProductDetailsLinkSection link={assemblyDetailsLink}>Download Assembly Details</PDPProductDetailsLinkSection></div>;
    $[8] = assemblyDetailsLink;
    $[9] = tearSheetLink;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t5 || $[13] !== t6) {
    t7 = <PDPInfoSectionLayout heading={t2}>{t5}{t6}</PDPInfoSectionLayout>;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default PDPInfoDetailsSection;
function _temp(t0) {
  const {
    label,
    description
  } = t0;
  return <div key={`${label}:${description}`} className="break-inside-avoid mb-6"><div className="text-sm font-bold text-gray">{label}</div><div className="text-sm text-gray pb-0">{description}</div></div>;
}